import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '@/components/ui/badge';
const statusConfig = {
    pending: {
        label: 'Pending',
        variant: 'warning',
    },
    active: {
        label: 'Active',
        variant: 'success',
    },
    suspended: {
        label: 'Suspended',
        variant: 'danger',
    },
};
export function AccountStatusBadge({ status, className }) {
    const config = statusConfig[status];
    return (_jsx(Badge, { variant: config.variant, className: className, children: config.label }));
}
